export default __webpack_public_path__ + "9dd88a39cbad16aa5e28db1c344621fa.png";